import { useEffect } from 'react';
import {
  CapacityManagementRootResponse,
  CorrectionsParams,
  CorrectionsResponse,
} from 'src/apis/capacity-management/types';
import { CapacityManagementRootRequest } from 'src/apis/capacity-management/use-capacity-management-root';
import { useAxios } from 'src/hooks/use-axios';
import { Forbidden } from 'src/utils/errors';
import urlTemplate from 'url-template';

type HookConfig = {
  capacityManagementRoot: CapacityManagementRootRequest;
  params: CorrectionsParams;
};

type RequestOptions = {
  rootData: CapacityManagementRootResponse;
  params: CorrectionsParams;
};

export function useCorrections({ capacityManagementRoot, params }: HookConfig) {
  const corrections = useAxios(
    (axios, signal, { rootData, params }: RequestOptions) => {
      if (!rootData._links?.corrections) throw new Forbidden();

      const url = urlTemplate
        .parse(rootData._links.corrections.href)
        .expand({});

      return axios.request<CorrectionsResponse>({
        signal,
        url,
        params,
      });
    },
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!capacityManagementRoot.response) return;

    const rootData = capacityManagementRoot.response.data;
    const options = { rootData, params };

    corrections.execute(options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [capacityManagementRoot.response, params]);

  return corrections;
}

export type CorrectionsRequest = ReturnType<typeof useCorrections>;
